import styled from 'styled-components';

import { IconStaticProps, JustIcon, JustIconStyledComponent } from '../../../../atoms/Icon/Icon';
import toastSuccessIcon from './toastSuccess.svg';

export const ToastSuccess = styled(JustIcon).attrs({
  alt: 'toastSuccess',
  icon: toastSuccessIcon,
  width: '32px',
  height: '32px',
})`` as JustIconStyledComponent<IconStaticProps>;
